// Scope groups organized by functionality
export const SCOPE_GROUPS = [
    {
        header: 'Shop Management',
        description: 'Access to your shop information, including contact information and settings',
        scopes: [
            {
                value: 'shop_read',
                label: 'Read',
            },
        ],
    },
    {
        header: 'Products',
        description: 'Read and write product data',
        scopes: [
            {
                value: 'offer_read',
                label: 'Read',
            },
            {
                value: 'offer_write',
                label: 'Write',
            },
        ],
    },
    {
        header: 'Webhooks',
        description: 'Manage webhook configurations and view webhook history',
        scopes: [
            {
                value: 'webhook_read',
                label: 'Read',
            },
            {
                value: 'webhook_write',
                label: 'Write',
            },
        ],
    },
    {
        header: 'Orders',
        description: 'Read and write order data',
        scopes: [
            {
                value: 'order_read',
                label: 'Read',
            },
        ],
    },
    {
        header: 'Memberships',
        description: 'Read and write membership data',
        scopes: [
            {
                value: 'memberships_read',
                label: 'Read',
            },
        ],
    },
    {
        header: 'Promotions',
        description: 'Read and write promotion data',
        scopes: [
            {
                value: 'promotions_read',
                label: 'Read',
            },
            {
                value: 'promotions_write',
                label: 'Write',
            },
        ],
    },
    {
        header: 'Giveaways',
        description: 'Read and write giveaway data',
        scopes: [
            {
                value: 'giveaway_read',
                label: 'Read',
            },
            {
                value: 'giveaway_write',
                label: 'Write',
            },
        ],
    },
    {
        header: 'Donations',
        description: 'Read and write donation data',
        scopes: [
            {
                value: 'donation_read',
                label: 'Read',
            },
        ],
    },
    {
        header: 'Fulfillment',
        description: 'Read and write fulfillment data',
        scopes: [
            {
                value: 'fulfillment_write',
                label: 'Write',
            },
        ],
    },
    {
        header: 'Thank yous',
        description: 'Read and write thank you data',
        scopes: [
            {
                value: 'thankyou_read',
                label: 'Read',
            },
        ],
    },
];
